import { container } from "tsyringe";
import { useMutation, useQueryClient } from "@tanstack/vue-query";

// entities
import { AcademyRegistrationRequestQueryKeys } from "@/entities/academy-registration-request/infrastructure/query-keys";
import {
    AcademyRegistrationRequestRepository,
    RequestPatchAcademyRegistrationRequestPayload,
} from "@/entities/academy-registration-request/domain/repository";
import { AcademyRegistrationRequestStatus } from "@/entities/academy-registration-request/domain/enums";

// features
import type { UseMutationApproveRegistrationUserProps } from "@/features/pending-registration/models/interface";

export const useMutationApproveRegistrationUser = ({
    id,
    academyId,
    userId,
    onSuccessCallback,
    onErrorCallback,
}: UseMutationApproveRegistrationUserProps) => {
    const queryClient = useQueryClient();

    const academyRegistrationRequestRepository =
        container.resolve<AcademyRegistrationRequestRepository>(
            "AcademyRegistrationRequestRepository",
        );

    const { mutate: approveRegistrationUser, isPending } = useMutation({
        throwOnError: false,
        ...AcademyRegistrationRequestQueryKeys.academy_registration_user.approve(
            id,
            academyId,
            userId,
        ),
        mutationFn: async () => {
            const payload: RequestPatchAcademyRegistrationRequestPayload = {
                academyRegistrationRequestId: id,
                requestDto: {
                    status: AcademyRegistrationRequestStatus.Approved,
                    academyId,
                    targetUserId: userId,
                },
            };
            const response =
                await academyRegistrationRequestRepository.patchAcademyRegistrationRequest(payload);

            return response;
        },
        onSuccess: () => {
            // registration list 를 갱신합니다. (전체)
            queryClient.invalidateQueries({
                queryKey: AcademyRegistrationRequestQueryKeys.academy_registration_requests._def,
            });

            if (onSuccessCallback) {
                onSuccessCallback();
            }
        },
        onError: (error) => {
            if (onErrorCallback) {
                onErrorCallback(error);
            }
        },
    });

    return {
        approveRegistrationUser,
        isPending,
    };
};
